import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import FsLightbox from 'fslightbox-react';
import { useTranslation } from 'react-i18next';

import StringHelper from '../../helpers/string-helper';
import ObjectHelper from '../../helpers/object-helper';
import PropertyInfo from '../PropertyInfo';

// region Helpers

const findMainPhoto = photos => {
  let mainPhoto;
  let usingMain = true;

  mainPhoto = photos.find(photo => {
    return photo.main;
  });

  if (mainPhoto === null) {
    usingMain = false;

    mainPhoto = photos.find((photo, index) => {
      return index === 0;
    });
  }

  return { photo: mainPhoto, usingMain };
};

const findSecondayPhotos = (photos, usingMain) => {
  if (usingMain) {
    return photos.filter(photo => !photo.main).slice(0, 3);
  }
  return photos.filter((photo, index) => index >= 1 && index <= 3);
};

const hasSecondaryPhotos = (firstPhoto, secondPhoto) => {
  return (
    firstPhoto &&
    firstPhoto.url &&
    StringHelper.isNotEmpty(firstPhoto.url) &&
    secondPhoto &&
    secondPhoto.url &&
    StringHelper.isNotEmpty(secondPhoto.url)
  );
};

// endregion

const MainGallery = props => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const { t } = useTranslation();
  const { photos, property } = props;

  // region Events Handlers
  const photoOpenHandler = index => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: index + 1,
    });
  };
  // endregion

  if (!photos || photos.length <= 0) {
    return null;
  }

  let photosFiles = [];

  const { photo: mainPhoto, usingMain } = findMainPhoto(photos);
  const [firstPhoto, secondPhoto, thirdPhoto] = findSecondayPhotos(photos, usingMain);
  const showSecondaryPhotos = hasSecondaryPhotos(firstPhoto, secondPhoto);
  const showThirdPhoto = thirdPhoto && StringHelper.isNotEmpty(thirdPhoto.url);
  const showMainPhoto =
    ObjectHelper.isObject(mainPhoto) &&
    ObjectHelper.propertyExists(mainPhoto, 'url');

  if (showMainPhoto) {
    photosFiles.push(mainPhoto.url);
  }

  if (showSecondaryPhotos) {
    photosFiles.push(firstPhoto.url);
    photosFiles.push(secondPhoto.url);
    if (showThirdPhoto) {
      photosFiles.push(thirdPhoto.url);
    }
  }

  const otherPhotos = photos.filter(photo => !photosFiles.includes(photo.url));

  photosFiles = [...photosFiles, ...otherPhotos.map(photo => photo.url)];

  if (!showMainPhoto && !showSecondaryPhotos) {
    return null;
  }


  return (
    <Fragment>
      <div className="pictures">
        <div className="card-body pb-0">
          {showMainPhoto && (
            <div
              className="gallery-main"
              style={{ backgroundImage: `url('${mainPhoto.url}')` }}
              onClick={() => photoOpenHandler(0)}
            >
              <div className="gallery-main-overlay">
                <span>{t('gallery.viewGallery')}</span>
              </div>
            </div>
          )}
          {showSecondaryPhotos && (
            <div className="gallery-strip">
              <div
                className="gallery-thumb"
                style={{ backgroundImage: `url('${firstPhoto.url}')` }}
                onClick={() => photoOpenHandler(1)}
              />
              <div
                className="gallery-thumb"
                style={{ backgroundImage: `url('${secondPhoto.url}')` }}
                onClick={() => photoOpenHandler(2)}
              >
                {!showThirdPhoto && photos.length > 3 && (
                  <div className="gallery-count">
                    <span>{t('gallery.viewAllPhotos', { count: photos.length })}</span>
                  </div>
                )}
              </div>
              {showThirdPhoto && (
                <div
                  className="gallery-thumb"
                  style={{ backgroundImage: `url('${thirdPhoto.url}')` }}
                  onClick={() => photoOpenHandler(3)}
                >
                  {photos.length > 4 && (
                    <div className="gallery-count">
                      <span>{t('gallery.viewAllPhotos', { count: photos.length })}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        <PropertyInfo property={property} />
      </div>

      <FsLightbox
        toggler={lightboxController.toggler}
        slide={lightboxController.slide}
        sources={photosFiles}
        type="image"
        customAttributes={photosFiles.map(() => ({
          style: {
            borderRadius: '14px',
            border: '8px solid #ffffff',
            boxShadow: '0 8px 40px rgba(0,0,0,0.55)',
            boxSizing: 'border-box',
            width: '85vw',
            maxWidth: '860px',
            height: '70vh',
            maxHeight: '580px',
            objectFit: 'contain',
          },
        }))}
      />
    </Fragment>
  );
};

MainGallery.propTypes = {
  photos: PropTypes.array.isRequired,
  property: PropTypes.object.isRequired,
};

export default MainGallery;
